<template>
    <div class="container" style="padding-top: 10%;">
    </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ServiceFunctions } from '@/wam/modules/service';
import store from '@/store';
import auth from '@/auth';

export default {
  name: 'logout',
  beforeCreate () {
    // store.commit('ws_status', false);
    // auth.logout(this, '/login');
  },
  mounted: function () {
    if (localStorage.getItem('access_token')) {
      let query = '';
      let data = {};
      ServiceFunctions.logout(query, data)
        .then(resp => {
          console.log('logout ..');
          auth.logout(this, '/');
        });
    } else {
      auth.logout(this, '/');
    }
    // auth.logout(this, '/login');
  }
};
</script>
